<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">MobilePay</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'mobile']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Setup</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col-12 p-lg-4 d-flex flex-column">
					<div>Focus MobilePay Enabled</div>
					<div class="descriptionText">
						MobilePay allows guests to scan a QR code an pay their check via credit card
						<!-- , ApplePay,
                                GooglePay or previously used
                                credit cards. -->
					</div>
					<div class="mb-3">
						<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.mobilePayEnabled"> </p-inputSwitch>
					</div>
					<div>Allow previously used & stored credit cards</div>
					<div class="descriptionText">
						MobilePay will store the credit card info from previous MobilePay transactions for your venue and allow guests to easily use them in the
						future.
					</div>
					<div class="descriptionText">Only venues using Focus POS with Shift4 Payments have access to this feature.</div>
					<div class="mb-3">
						<p-inputSwitch
							(onChange)="changesToSave = true"
							[(ngModel)]="venueSvc.ooVenue.mobilePayAllowPreviousCard"
							[disabled]="venueSvc.ooVenue.ccProcessor !== 1"
						>
						</p-inputSwitch>
					</div>
					<div>Send Admin email after Payment</div>
					<div class="descriptionText">
						MobilePay will send the venue admin (email address from General tab) an email after each payment has been made.
					</div>
					<div class="mb-3">
						<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.mobilePayAdminEmailOnPayment"></p-inputSwitch>
					</div>
				</div>
				<div class="p-col-12 p-lg-4 d-flex flex-column">
					<div>Tip Rates %</div>
					<div class="mb-2">
						<p-inputNumber
							(onInput)="changesToSave = true"
							[(ngModel)]="venueSvc.ooVenue.mobilePayTip1"
							mode="decimal"
							min="0.00"
							max="1.00"
							[minFractionDigits]="2"
							[maxFractionDigits]="2"
						>
						</p-inputNumber>
					</div>
					<div class="mb-2">
						<p-inputNumber
							(onInput)="changesToSave = true"
							[(ngModel)]="venueSvc.ooVenue.mobilePayTip2"
							mode="decimal"
							min="0.00"
							max="1.00"
							[minFractionDigits]="2"
							[maxFractionDigits]="2"
						>
						</p-inputNumber>
					</div>
					<div class="mb-2">
						<p-inputNumber
							(onInput)="changesToSave = true"
							[(ngModel)]="venueSvc.ooVenue.mobilePayTip3"
							mode="decimal"
							min="0.00"
							max="1.00"
							[minFractionDigits]="2"
							[maxFractionDigits]="2"
						>
						</p-inputNumber>
					</div>
					<div class="mb-2 w-100">
						<div class="d-flex w-100">
							<div class="my-auto">
								<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.mobilePayTipCustom"></p-inputSwitch>
							</div>
							<div class="my-auto ms-2">Custom tip</div>
						</div>
					</div>
					<div class="mb-2">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#ccSurchargeValue
								name="ccSurchargeValue"
								type="text"
								[(ngModel)]="venueSvc.ooVenue.mobilePayCCSurcharge"
								(change)="changesToSave = true"
								class="w-100"
							/>
							<label for="ccSurchargeValue">Cash Discount Text</label>
						</span>
					</div>
				</div>
				<div class="p-col-12 p-lg-4 d-flex flex-column">
					<div>MobilePay Survey</div>
					<div class="descriptionText">
						Guests will be prompted for a simple thumbs up/thumbs down survey at the bottom of each receipt or after MobilePay payment
					</div>
					<div class="mb-3">
						<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.mobilePaySurvey"> </p-inputSwitch>
					</div>
					<div>Send email to Admin after Survey</div>
					<div class="descriptionText">
						MobilePay will send the Venue Admin (email from General Tab) an email after each survey. Both positive and negative surveys will be
						sent.
					</div>
					<div class="mb-3">
						<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.mobilePayAdminEmailOnSurvey"> </p-inputSwitch>
					</div>
					<div>Request Yelp! Review for positive surveys</div>
					<div class="descriptionText">
						When enabled, guests will be prompted to leave a Yelp! review for a positive survey. Negative surveys will not be prompted.
					</div>
					<div class="mb-3">
						<p-inputSwitch (onChange)="changesToSave = true" [(ngModel)]="venueSvc.ooVenue.yelpSurvey"> </p-inputSwitch>
					</div>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'sms']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">MobilePay SMS</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col-12 p-lg-4 d-flex flex-column">
					<div>MobilePay SMS Message</div>
					<div class="mb-3">
						<textarea
							pInputTextarea
							[(ngModel)]="venueSvc.ooVenue.mobilePaySmsMessage"
							[maxlength]="500"
							style="height: 100px; width: 100%"
							(change)="changesToSave = true"
						></textarea>
					</div>
				</div>
				<div class="p-col-12 p-lg-4 d-flex flex-column">
					<div>MobilePay Menu Item</div>
					<div class="descriptionText">
						Ringing this menu item in Focus will trigger a MobilePay SMS to be sent to the guest attached to the check.
					</div>
					<div class="mb-3">
						<p-dropdown
							placeholder="MobilePay Trigger Item..."
							[options]="venueSvc.ooMenuItems"
							optionLabel="name"
							optionValue="menuItemKey"
							name="menuItemList"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							[filter]="true"
							filterBy="name,displayName"
							[(ngModel)]="venueSvc.ooVenue.mobilePayMenuItemKey"
							[style]="{ width: '100%' }"
							appendTo="body"
							(onChange)="changesToSave = true"
						></p-dropdown>
					</div>
				</div>
				<div class="p-col-12 p-lg-4 d-flex flex-column"></div>
			</div>
		</p-tabPanel>
	</p-tabView>
</div>
